import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {gsap} from "gsap";
import {Game} from "../Game";
import {GameModeNames} from "../server/GameModeNames";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {IMonster} from "../server/IData";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";

export class NormalBetPresentation implements FlowStatePresentation {

    public start(flowStateController: FlowStateController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                flowStateController.finish();
            }
        });

        Game.monsterSymbolsGoingDead = [];
        Game.normalIdle.killIdle();

        Game.mxSymbol = null;
        Game.mxVSymbolReelId = -6;
        Game.mxVSymbolRowIdBeforeCollapse = -6;
        Game.hasMxSymbolLanded = false;

        // #230
        Game.monsterReelsView.toggleMask(true);

        const reelSpinSound: string = "reelSpin" + MathHelper.randomIntInRange(1, 4);
        tl.add(() => {
            Game.soundPlayer.playSound(reelSpinSound, 1);
        }, 0);

        for (let i: number = 0; i < Game.ACTIVE_REELS_NUM; i++) {
            tl.add(Game.reelsView.reelModels[i].allOut(), (0.1 * i));
        }

        if (Game.model.data.nextMode === GameModeNames.NORMAL) {
            if (Game.hasGridExpanded) {
                tl.add(Game.resetExpandedElements());
            }
            Game.multiplier.resetMultiplier(1);

            Game.hasGridExpanded = false;

            Game.monsterCarriedSymbols = [[], [], [], []];
            Game.monsterExtraCarriedSymbols = [[], [], [], []];

            // since life has to be 3 on spin button press irrespective of coming out from mayhem spins
            Game.reelCorners.resetLifeOfAllCorners(3);
        } else {
            if (Game.model.data.monsters) {
                Game.model.data.monsters.forEach((monster: IMonster) => {
                    Game.reelCorners.resetLifeOfACorner((monster.symbol - Game.MONSTER_SYMBOLS.length), monster.lifeLeft);
                });
            }

            // #286
            if ((Game.model.data.nextMode === GameModeNames.FREESPIN) && (Game.model.data.mayhemSpin)) {
                Game.reelCorners.resetLifeOfAllCorners(1);
            }
        }

        Game.scatterInventory.stopAllScatters();

        if (Game.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
            tl.timeScale(2);
        }
    }
}